import { createFileRoute } from '@tanstack/react-router';

import { OwnerEditorPage } from '../features/demand/owners/components/OwnerEditorPage';

export const Route = createFileRoute('/demand/owners/edit/$ownerId')({
  component: OwnerEditRoute,
});

function OwnerEditRoute() {
  const { ownerId } = Route.useParams();
  return <OwnerEditorPage ownerId={ownerId} />;
}
